"use client";
import Cookies from "js-cookie";
import { getEnv } from "@/env";

const logoutUser = () => {
  const lmsBase = getEnv("NEXT_PUBLIC_LMS_BASE_URL");
  try {
    // Reset Segment user identity (clears ajs_user_id cookie and user traits)
    if (
      typeof window !== "undefined" &&
      window.analytics &&
      window.analytics.user
    ) {
      window.analytics.user().id(null); // Clears the ajs_user_id cookie and localStorage value

      //Prevent LMS from reinferring the ajs_user_id cookie
      Cookies.remove(getEnv("NEXT_PUBLIC_ACCESS_TOKEN_COOKIE_NAME"));
      Cookies.remove(getEnv("NEXT_PUBLIC_USER_INFO_COOKIE_NAME"));
      Cookies.remove("lms_sessionid");
    }
  } catch (error) {
    // Log error but don't block logout process
    console.error("Error resetting Segment analytics during logout:", error);
  }

  // Redirect to LMS logout to handle server-side session cleanup
  // Add a small delay to ensure browser processes cookie deletion
  // before navigating away
  setTimeout(() => {
    window.location.href = `${lmsBase}/logout`;
  }, 300);
};

export default logoutUser;
